<template>
  <div class="ViewClockDetailsModal">
    <el-dialog
      title="每日打卡"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      width="80%"
    >
      <div class="content">
        <el-form ref="form" :model="formData" label-width="115px">
          <el-form-item label="名称/课程名称:">
            <el-input
              disabled
              style="width: 100%"
              v-model="formData.name"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="formData.materialUrl" label="内容音频:">
            <audio
              :src="formData.materialUrl"
              :loop="false"
              controls
              preload="auto"
              controlsList="nodownload noplaybackrate"
              ref="audioRef"
            ></audio>
          </el-form-item>
          <el-form-item label="内容概述:">
            <el-input
              type="textarea"
              style="width: 100%"
              disabled
              v-model="formData.displayDescription"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViewClockDetailsModal",
  props: {
    rowDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: {
        name: "",
        materialUrl: "",
        displayDescription: "",
      },
    };
  },
  computed: {
    ...mapState("pluginCenter", ["ClockDetailsModalVisible"]),
    visible: {
      get() {
        return this.$store.state.pluginCenter.ClockDetailsModalVisible;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "ClockDetailsModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    handleOpen() {
      Object.keys(this.formData).map((key) => {
        this.formData[key] = this.rowDetails[key];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ViewClockDetailsModal {
  ::v-deep .el-dialog {
    min-width: 750px;
    height: 600px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 35px;
  }

  ::v-deep audio {
    margin-top: 10px;
    height: 35px;
  }

  ::v-deep .el-textarea__inner {
    min-height: 150px !important;
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #606266;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: default;
  }

  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: default;
  }
}
</style>
